import React from 'react'

function VideoPlatform(props) {
  const { previewVideo, handleChange } = props
  return (
    <>
      <div style={{ width: '50%' }}>
        <label htmlFor='videoPlatform'>Platform:</label>
        <select
          id='videoPlatform'
          name='videoPlatform'
          className='form-control'
          value={previewVideo.videoPlatform}
          onChange={handleChange}
        >
          <option value=''></option>
          <option value='youtube'>YouTube</option>
          <option value='X'>Twitter</option>
          <option value='instagram'>Instagram</option>
          {/* Add more options for other platforms if needed */}
        </select>
      </div>
    </>
  )
}

export default VideoPlatform
